import { useEffect, useState } from "react";

/**
 * Web-site visit context. When a visitor enters through an owner web-site,
 * we remember it (per browser tab, via sessionStorage) so that navigating to a
 * property detail keeps them inside the owner's storefront instead of the AVASA
 * master site. Context clears when they open the AVASA homepage or close the tab.
 */
const KEY = "avasa_minisite_ctx";
const EVENT = "avasa-minisite-ctx";

export function getMiniSiteContext() {
  try {
    const raw = sessionStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function setMiniSiteContext(ctx) {
  if (!ctx || !ctx.slug) return;
  const prev = getMiniSiteContext();
  const merged = { ...(prev || {}), ...ctx };
  sessionStorage.setItem(KEY, JSON.stringify(merged));
  window.dispatchEvent(new CustomEvent(EVENT));
}

export function clearMiniSiteContext() {
  if (!sessionStorage.getItem(KEY)) return;
  sessionStorage.removeItem(KEY);
  window.dispatchEvent(new CustomEvent(EVENT));
}

export function useMiniSiteContext() {
  const [ctx, setCtx] = useState(getMiniSiteContext);
  useEffect(() => {
    const sync = () => setCtx(getMiniSiteContext());
    window.addEventListener(EVENT, sync);
    window.addEventListener("storage", sync);
    return () => {
      window.removeEventListener(EVENT, sync);
      window.removeEventListener("storage", sync);
    };
  }, []);
  return ctx;
}
